/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Record_Voiceover_TitleInputs */

const en_event_ad_record_voiceover_title = /** @type {(inputs: Event_Ad_Record_Voiceover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record your own voiceover`)
};

const fr_event_ad_record_voiceover_title = /** @type {(inputs: Event_Ad_Record_Voiceover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrez votre propre voix off`)
};

const de_event_ad_record_voiceover_title = /** @type {(inputs: Event_Ad_Record_Voiceover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nehmen Sie Ihre eigene Sprachaufnahme auf`)
};

const it_event_ad_record_voiceover_title = /** @type {(inputs: Event_Ad_Record_Voiceover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra la tua voce fuori campo`)
};

const ru_event_ad_record_voiceover_title = /** @type {(inputs: Event_Ad_Record_Voiceover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запишите свой собственный закадровый голос`)
};

const es_event_ad_record_voiceover_title = /** @type {(inputs: Event_Ad_Record_Voiceover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graba tu propia voz en off`)
};

const zh_cn2_event_ad_record_voiceover_title = /** @type {(inputs: Event_Ad_Record_Voiceover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录制你自己的旁白`)
};

const ja_event_ad_record_voiceover_title = /** @type {(inputs: Event_Ad_Record_Voiceover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分のナレーションを録音する`)
};

const hi_event_ad_record_voiceover_title = /** @type {(inputs: Event_Ad_Record_Voiceover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी खुद की वॉइसओवर रिकॉर्ड करें`)
};

const pt_pt2_event_ad_record_voiceover_title = /** @type {(inputs: Event_Ad_Record_Voiceover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grave sua própria narração.`)
};

/**
* | output |
* | --- |
* | "Record your own voiceover" |
*
* @param {Event_Ad_Record_Voiceover_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_record_voiceover_title = /** @type {((inputs?: Event_Ad_Record_Voiceover_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Record_Voiceover_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_record_voiceover_title(inputs)
	if (locale === "de") return de_event_ad_record_voiceover_title(inputs)
	if (locale === "it") return it_event_ad_record_voiceover_title(inputs)
	if (locale === "ru") return ru_event_ad_record_voiceover_title(inputs)
	if (locale === "es") return es_event_ad_record_voiceover_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_record_voiceover_title(inputs)
	if (locale === "ja") return ja_event_ad_record_voiceover_title(inputs)
	if (locale === "hi") return hi_event_ad_record_voiceover_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_record_voiceover_title(inputs)
	return en_event_ad_record_voiceover_title(inputs)
});